var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Menu"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Components","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Menu","transform":"translate(0.000000, 1.000000)","stroke":"#002B38","strokeWidth":"2.5"},[React.createElement("path",{"d":"M0.571428571,0.588235294 L23.4285714,0.588235294","id":"Line-2","key":0}),React.createElement("path",{"d":"M0.571428571,10 L23.4285714,10","id":"Line-2","key":1}),React.createElement("path",{"d":"M0.571428571,19.4117647 L23.4285714,19.4117647","id":"Line-2","key":2})]))]);
}

MenuIcon.defaultProps = {"width":"20px","height":"22px","viewBox":"0 0 20 22","version":"1.1"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
